import Logo, { LogoProps } from './Logo';

export default Logo;
export type { LogoProps };
